<section class="product-preview">
  <!-- product images & videos -->
  <div class="product-preview__media">
    <!-- main image and options menu -->
    <div class="product-preview__media-container">
      <!-- media gallery -->
      <pwj-gallery
        [mediaData]="previewData()?.media || []"
        [mediaListCount]="3"
        [isColumnListMode]="true"
        previewWidth="424"
        previewHeight="318"
        [previewPriority]="true"
        listImgWidth="88"
        listImgHeight="66"
        previewWidthClass="!w-full !max-w-full md:!w-424 md:!max-w-424"
        previewHeightClass="!h-244 sm:!h-320 md:!h-424"
        [previewAlt]="
          (previewData()?.title | translateData) || 'product'
        "></pwj-gallery>
    </div>
  </div>
  <!-- product details content -->
  <div class="product-preview__content">
    <div class="product-title">
      <div class="product-title__text">
        <h3 class="product-title__heading">
          {{ (previewData()?.title | translateData) || '-' }}
        </h3>
        <p class="product-title__subtitle">
          {{ (previewData()?.subTitle | translateData) || '-' }}
        </p>
      </div>
      @if (previewData()?.specialist_verified) {
        <img
          class="product-title__icon"
          ngSrc="assets/icons/golden-verify.svg"
          width="54"
          height="54"
          alt="verify" />
      }
    </div>
    <!-- product description -->
    @if (descriptionPreviewText(); as descriptionText) {
      <div class="product-description">
        <p class="product-description__text">
          {{ descriptionText.slice(0, 140) }}
          @if (descriptionText.length > 140) {
            <span class="more-btn" (click)="goToDescription()">{{
                'global.more' | translate
              }}</span>
          }
        </p>
      </div>
    }
    <!-- product properties -->
    <div class="product-properties">
      @for (property of productProperties; track property.name) {
        @if (property.value) {
          <pwj-card-property [cardPropertyData]="property"></pwj-card-property>
        }
      }
    </div>
    <!-- product details bottom -->
    <div class="details-options">
      <!-- price section (only when at least one price is present) -->
      @if (previewData()?.highest_price || previewData()?.lowest_price) {
        <div class="details-options__price">
          <p class="price-label">{{ 'global.price' | translate }}</p>
          <pwj-item-prices
            [highestPrice]="previewData()?.highest_price"
            [lowestPrice]="previewData()?.lowest_price"></pwj-item-prices>
        </div>
      }
      <!-- contact and request buttons -->
      <div class="details-options__btns">
        <div class="details-options__btn-slot">
          <pwj-button
            variant="primary"
            size="large"
            icon="message-dots"
            iconClasses="!text-4xl"
            matomoClickCategory="Product"
            matomoClickAction="Message"
            matomoClickName="Product Details"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            (clicked)="sendMessage()"
            >{{
              (isSubscribed()
                ? 'products.contactSupplier'
                : 'products.contactSupport'
              ) | translate
            }}</pwj-button
          >
        </div>
        <!-- temporary
        <pwj-button
          variant="secondary"
          size="large"
          icon="chevron-right"
          matomoClickCategory="Contact"
          matomoClickAction="View"
          matomoClickName="Product Details"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          (click)="contactUs()"
        >{{ 'global.contact' | translate }}
        </pwj-button
        >
        -->

        <!-- submit button (temporary hidden)
        @if (isUserLoggedIn) {
          <div class="details-options__btn-slot">
            <pwj-button
              [variant]="!userName ? 'secondary' : 'primary'"
              size="large"
              icon="chevron-right"
              matomoClickCategory="Product"
              matomoClickAction="Request"
              matomoClickName="Product Details"
              [rotateIconInRtl]="true"
              [iconReversePosition]="true"
              (click)="submitARequest()"
              [class.pointer-events-none]="!userName"
              [disabled]="!userName"
            >{{ 'global.submitARequest' | translate }}
            </pwj-button
            >
          </div>
        } @else {
          <div class="details-options__btn-slot">
            <pwj-register-button title="global.submitARequest"
                                 size="large"
                                 matomoClickCategory="Authentication"
                                 matomoClickAction="Login-Register"
                                 matomoClickName="Product Details"></pwj-register-button>
          </div>
        }
        -->
      </div>
    </div>
  </div>
</section>
